"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const graphql_tag_1 = tslib_1.__importDefault(require("graphql-tag"));
const DataProvider_1 = tslib_1.__importDefault(require("../DataProvider"));
class ReviewProvider extends DataProvider_1.default {
    get fragments() {
        return {
            ReviewStatistic: () => `
        ... on ReviewStatistic {
          averageRating
          count
          subject {
            subjectId
            subjectType
          }
        }
      `,
            Review: () => `
        ... on Review {
          id
          subject {
            subjectId
            subjectType
          }
          reviewerId
          reviewerUser {
             ${this.getFragment("UserPublicData")}
          }
          rating
          comment
          time
        }
      `,
        };
    }
    find({ data }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.query({
                query: graphql_tag_1.default `
        query ReviewFind($data: InputReviewSearch!) {
          reviewFind(data: $data) {
            result {
              ${this.getFragment("Review")}
            }
            hasNextPage
            hasPrevPage
            page
            size
            totalPages
            totalRecords
          }
        }
      `,
                variables: { data },
            });
            return response.data.reviewFind;
        });
    }
    getStats({ subjects }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.query({
                query: graphql_tag_1.default `
        query ReviewGetStats($subjects: [InputReviewSubject]!) {
          reviewGetStats(subjects: $subjects) {
            ${this.getFragment("ReviewStatistic")}
          }
        }
      `,
                variables: { subjects },
            });
            return response.data.reviewGetStats;
        });
    }
    create({ data }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.mutate({
                mutation: graphql_tag_1.default `
        mutation ReviewCreate($data: InputReviewCreate!) {
          reviewCreate(data: $data) {
            ${this.getFragment("Review")}
          }
        }
      `,
                variables: { data },
            });
            return response.data.reviewCreate;
        });
    }
    delete({ reviewId }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.mutate({
                mutation: graphql_tag_1.default `
        mutation ReviewDelete($reviewId: ID!) {
          reviewDelete(reviewId: $reviewId)
        }
      `,
                variables: { reviewId },
            });
            return response.data.reviewDelete;
        });
    }
}
exports.ReviewProvider = ReviewProvider;
//# sourceMappingURL=ReviewProvider.js.map